module.exports = __webpack_public_path__ + "img/DIMENSIONAL_Logo_transp.ac95b9bb.png";